module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section footer"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content footer__content"
  }, [_vm._m(0), _vm._v(" "), (_vm.showShare) ? _c('div', {
    staticClass: "footer__content-block mb-2"
  }, [_c('span', {
    staticClass: "footer__label mr-3"
  }, [_vm._v("Share:")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "twitter",
      "data-title": "Britain, Take A Bow!",
      "data-url": "https://britaintakeabow.org",
      "src": require("../assets/icon_twitter.svg"),
      "alt": "Twitter icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "facebook",
      "data-url": "https://britaintakeabow.org",
      "src": require("../assets/icon_facebook.svg"),
      "alt": "Facebook icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "linkedin",
      "data-url": "https://britaintakeabow.org",
      "src": require("../assets/icon_linkedin.svg"),
      "alt": "LinkedIn icon"
    }
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__content-block mb-2"
  }, [_c('a', {
    staticClass: "footer__label mr-3",
    attrs: {
      "href": "mailto:btab@tuimedia.com?subject=Britain Take A Bow"
    }
  }, [_vm._v("Contact")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25c3b6cd","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 222
// module chunks = 1